import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dStorage from "../Restaumatic.Storage/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const $PersistentInitializer = (_1, _2, _3) => ({tag: "PersistentInitializer", _1, _2, _3});
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableMaybe);
const subscribeDyn_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn_({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost
});
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const PersistentInitializer = value0 => value1 => value2 => $PersistentInitializer(value0, value1, value2);
const initializePersistentIniti = dictInitialize => dictDecode => {
  const getItem = Restaumatic$dStorage.getItem(dictDecode);
  return dictEncode => dictMerge => dictQuery => {
    const queryLax = Restaumatic$dForm$dQuery.queryWith(dictQuery)(Restaumatic$dForm$dQuery.Lax);
    return dictHasFieldId => (
      {
        makeImpl: s => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(s)(opts))(v => {
          const $0 = v.field;
          return Specular$dInternal$dRIO.pureImpl({
            field: $0,
            init: iv => v1 => {
              const $1 = v1._2;
              const $2 = v1._1;
              return Specular$dInternal$dRIO.bindImpl(v.init(iv)(v1._3))(() => {
                const $3 = dictHasFieldId.getFieldId($0);
                const key = (() => {
                  if ($1.tag === "Nothing") { return $3; }
                  if ($1.tag === "Just") { return $1._1; }
                  $runtime.fail();
                })();
                return Specular$dInternal$dRIO.bindImpl(getItem($2)(key))(m_initialValue => Specular$dInternal$dRIO.bindImpl(for_(m_initialValue)(initialValue => dictMerge.merge(initialValue)($0)))(() => Restaumatic$dForm$dInternal.afterInitialized(subscribeDyn_(traverse_(value => $2.setRawItem(key)(Foreign$dInternal$dStringify.unsafeStringify(dictEncode.encode(value)))))(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(queryLax($0))))));
              });
            }
          });
        })
      }
    );
  };
};
const persistentAtKey = storage => key => PersistentInitializer(storage)(Data$dMaybe.$Maybe("Just", key));
const persistent = storage => PersistentInitializer(storage)(Data$dMaybe.Nothing);
export {$PersistentInitializer, PersistentInitializer, for_, initializePersistentIniti, persistent, persistentAtKey, subscribeDyn_, traverse_};
